import initCardSlider from './card-slider';

export default () => {
  initCardSlider();
}


// WEBPACK FOOTER //
// ./resources/assets/js/blocks/residential-complex/index.js